import axios from "axios";
import { apiUrl } from "../constant";

const BASE = `${apiUrl}/api/UnassignedReturns`;

export const getUnassignedFilterOptionsService = () => axios.get(`${BASE}/GetFilterOptions`);

export const getUnassignedSummaryService = (data) => axios.post(`${BASE}/GetSummary`, data);

export const getUnassignedReturnsService = (data) => axios.post(`${BASE}/GetUnassignedReturns`, data);

// formData carries packageId, useExistingImage and an optional image file (axios sets the multipart boundary).
export const extractUnassignedOcrService = (formData) => axios.post(`${BASE}/ExtractOcr`, formData);

export const matchUnassignedNotesService = (packageId, notes) =>
    axios.post(`${BASE}/MatchNotes?packageId=${encodeURIComponent(packageId)}`, { notes });

export const saveUnassignedNotesService = (data) => axios.put(`${BASE}/SaveNotes`, data);

export const assignUnassignedReturnService = (data) => axios.post(`${BASE}/Assign`, data);

export const bulkOcrAutoMatchService = (packageIds) => axios.post(`${BASE}/BulkOcrAutoMatch`, { packageIds });

export const bulkAssignManualService = (data) => axios.post(`${BASE}/BulkAssignManual`, data);
